module.exports = __webpack_public_path__ + "static/media/journal-accent.449bd2a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/journal-accent.svg
// module id = 173
// module chunks = 0